import { l } from '@manychat/manyui'

import { IBlock, IWaCatalogBlock } from 'common/builder/blocks/blockInterfaces'
import { FlowChartButtonBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonBuilder'
import {
  BlockConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { ButtonAppearance } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import { FlowChartCatalogBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartCatalogBlock'
import { BlockType } from 'common/builder/constants/BlockType'
import { getConnectedWhatsAppChannel } from 'common/core/selectors/channelSelectors'

export const CatalogBlockWhatsAppConverterRule: ConverterRule<
  IWaCatalogBlock,
  FlowChartCatalogBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) => entity?.type === BlockType.WA_CATALOG_MESSAGE,

  convert: (entity: IWaCatalogBlock, { fields, state }) => {
    const waChannelData = getConnectedWhatsAppChannel(state)
    let title = l.translate('View Catalog on WhatsApp')

    if (waChannelData?.business_account_name) {
      title = l.translate('View {name}’s Catalog on WhatsApp', {
        name: waChannelData.business_account_name,
      })
    }

    return {
      id: entity.id,
      type: FlowChartBlockType.CATALOG,
      data: {
        header: {
          title,
          subtitle: l.translate('Browse pictures and details of their offerings.'),
        },
        text: entity.content.body ? replaceFieldsInString(entity.content.body, fields) : null,
        footer: entity.content.footer ? replaceFieldsInString(entity.content.footer, fields) : null,
        button: new FlowChartButtonBuilder(`catalog_button_${entity.id}`)
          .withCaption(l.translate('View Catalog'))
          .withAppearance(ButtonAppearance.MENU)
          .build(),
      },
    }
  },
}
